/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoAppListAppData model module.
 * @module model/CampaignControllerDtoAppListAppData
 * @version 1.0
 */
class CampaignControllerDtoAppListAppData {
    /**
     * Constructs a new <code>CampaignControllerDtoAppListAppData</code>.
     * @alias module:model/CampaignControllerDtoAppListAppData
     */
    constructor() { 
        
        CampaignControllerDtoAppListAppData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoAppListAppData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoAppListAppData} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoAppListAppData} The populated <code>CampaignControllerDtoAppListAppData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoAppListAppData();

            if (data.hasOwnProperty('appNo')) {
                obj['appNo'] = ApiClient.convertToType(data['appNo'], 'Number');
            }
            if (data.hasOwnProperty('packageName')) {
                obj['packageName'] = ApiClient.convertToType(data['packageName'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('developer')) {
                obj['developer'] = ApiClient.convertToType(data['developer'], 'String');
            }
            if (data.hasOwnProperty('createAt')) {
                obj['createAt'] = ApiClient.convertToType(data['createAt'], 'Date');
            }
            if (data.hasOwnProperty('updateAt')) {
                obj['updateAt'] = ApiClient.convertToType(data['updateAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoAppListAppData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoAppListAppData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['packageName'] && !(typeof data['packageName'] === 'string' || data['packageName'] instanceof String)) {
            throw new Error("Expected the field `packageName` to be a primitive type in the JSON string but got " + data['packageName']);
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['developer'] && !(typeof data['developer'] === 'string' || data['developer'] instanceof String)) {
            throw new Error("Expected the field `developer` to be a primitive type in the JSON string but got " + data['developer']);
        }

        return true;
    }


}



/**
 * @member {Number} appNo
 */
CampaignControllerDtoAppListAppData.prototype['appNo'] = undefined;

/**
 * @member {String} packageName
 */
CampaignControllerDtoAppListAppData.prototype['packageName'] = undefined;

/**
 * @member {String} title
 */
CampaignControllerDtoAppListAppData.prototype['title'] = undefined;

/**
 * @member {String} developer
 */
CampaignControllerDtoAppListAppData.prototype['developer'] = undefined;

/**
 * @member {Date} createAt
 */
CampaignControllerDtoAppListAppData.prototype['createAt'] = undefined;

/**
 * @member {Date} updateAt
 */
CampaignControllerDtoAppListAppData.prototype['updateAt'] = undefined;






export default CampaignControllerDtoAppListAppData;

